import React from 'react';
import { useIntl } from 'react-intl';
import { Grid } from '@mui/material';

import { useSettings, Utils } from 'app/main/components';
import { CurrencyTextField } from 'app/main/components/fields';
import { InlineTitle } from 'app/main/modules/components/FastAddDialogSettingsManager';
import { roundDecimal } from 'app/main/components/Utils';

import { type OrdersLinesEditDialogSection } from '../OrdersLinesEditDialog';

export default function OrdersLinesEditDialogExpensesSection(props: OrdersLinesEditDialogSection) {
	const { t } = useSettings();
	const intl = useIntl();

	const unitExpensesHelperText = intl.formatMessage(
		{ id: 'orderLinesEditDialog.unitExpenses', defaultMessage: t('DETAILS_ORDERS_LINES_ORIGINAL_VALUE') },
		{ value: Utils.formatCurrency(props.model.orli_unit_expenses) }
	);

	function calcExpensesReverse(newTotalExpenses: number | null, quantity = 1) {
		if (!newTotalExpenses) {
			props.sendChange('orli_unit_expenses_custom', null);
		} else {
			const newExpenses = roundDecimal(newTotalExpenses / quantity, 2);
			props.sendMultipleChanges({
				...props.model,
				orli_quantity: props.model.orli_quantity || 1,
				orli_unit_expenses_custom: newExpenses
			});
		}
	}

	return (
		<>
			<InlineTitle text="ORDERS_LINES_EDIT_DIALOG_EXPENSES_SECTION" />
			{/* UNIT EXPENSES */}
			<Grid size={{ sm: 6, xs: 12 }}>
				<CurrencyTextField
					name="orli_unit_expenses_custom"
					label={t('DETAILS_ORDERS_LINES_FIELD_UNIT_EXPENSES')}
					helperText={
						props.model.orli_unit_expenses_custom >= 0 && props.model.orli_unit_expenses !== undefined
							? unitExpensesHelperText
							: undefined
					}
					value={props.model.orli_unit_expenses_custom || props.model.orli_unit_expenses}
					isEdit={props.canEditPrice}
					sendChange={props.sendChange}
				/>
			</Grid>
			{/* TOT EXPENSES */}
			<Grid size={{ sm: 6, xs: 12 }}>
				<CurrencyTextField
					name="orli_tot_expenses"
					label={t('DETAILS_ORDERS_LINES_FIELD_TOT_EXPENSES')}
					value={props.model.orli_tot_expenses}
					isEdit={props.canEditPrice}
					sendChange={(_, newValue) => calcExpensesReverse(newValue, props.model.orli_quantity)}
				/>
			</Grid>
		</>
	);
}
